import { mapState } from 'vuex'

export default {
  data() {
    return {
      navBar: [], // 顶部科室菜单
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    // if(this.userInfo && this.userInfo.Id) {
    //   this.getNavbar();
    // }
  },
  methods: {
    // 获取顶部科室菜单
    getNavbar() {
      this.$axios.post('/Api/Api/Web/Subject/GetUserDepartmentList').then(res => {
        this.navBar = res.Data;
        let index = res.Data.findIndex(item => item.Code == "other");
        if (index != -1) {
          this.navBar.splice(index, 1);
        }
      })
    },
    /* 模块关键字埋点  
    BPType: 1.页面点击  2.关键字  3.banner  4.悬浮框  5.开屏弹窗  6.页面访问
    Name: 模块名称
    TCode
    Url: 路由地址 */
    BuriedPoint(BPType, Name, TCode, Url, externalID, OtherId, Source) {
      return this.$axios.post('/Api/Api/Web/BuriedPoint/AddBP', {
        BPType,
        Name: Name ? Name : '',
        TCode: TCode ? TCode : '',
        Url: Url ? Url : '',
        externalID: externalID ? externalID : '',
        OtherId: OtherId ? OtherId : '',
        Source: Source ? Source : ''
      });
    }
  }
}